export const gravatarLink = (hash: string, dftl: string) => `https://www.gravatar.com/avatar/${hash}?d=${dftl}`;
export const imageDftl = (initials: string, color = '186e5d', bg = 'cbe9d2') =>
  `https://ui-avatars.com/api/${initials}/64/${bg}/${color}/2/0/1/1/true`;

export const getProfileUrl = (name: string, hash: string, color?: string, bg?: string) => {
  const initials = getInitials(name);
  color = color?.replace('#', '');
  bg = bg?.replace('#', '');
  return gravatarLink(hash, escape(imageDftl(initials, color, bg)));
};

export const getInitials = (name: string) => {
  return name.split(/[\s.]+/).slice(0, 2).map(e => e.substring(0, 1)).join('+');
};
